import type { Vehicle } from 'Types/vehicle';

import { getAlertCount, getVehicleHistoryChecksList } from './useVehicleHistoryChecks.helpers';
import type { VehicleHistoryCheckList } from './useVehicleHistoryChecks.types';

export interface UseVehicleHistoryChecks {
	alertCount: number;
	completedOnDate?: string;
	hasAlerts: boolean;
	list: VehicleHistoryCheckList[];
}

const useVehicleHistoryChecks = (historyChecks: Vehicle['historyChecks']): UseVehicleHistoryChecks => {
	const list = getVehicleHistoryChecksList(historyChecks);
	const alertCount = getAlertCount(list);
	const hasAlerts = Boolean(alertCount);
	const { completedOnDate } = historyChecks || {};

	return {
		alertCount,
		completedOnDate,
		hasAlerts,
		list,
	};
};

export default useVehicleHistoryChecks;
